import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_SALE_ORDER_SUCCESS,
  FETCH_ASSETS_BY_LOCATION_SUCCESS,
  FETCH_EQUIPMENT_SUB_TYPE_BY_ASSET_SUCCESS,
  FETCH_SALE_ORDER_SUCCESS,
  GET_SALE_ORDER_SUCCESS,
  SAVE_SALE_ORDER_QUERY, SET_CONTRACT_UPLOAD,
  UNMOUNT_SALE_ORDER_SUCCESS,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_SALE_ORDER_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SALE_ORDER_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_SALE_ORDER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_SALE_ORDER_SUCCESS,
    data
  };
};

export const fetchAssetsByLocationSuccess = ({ data }) => {
  return {
    type: FETCH_ASSETS_BY_LOCATION_SUCCESS,
    data,
  };
};

export const fetchEquipmentSubTypeSuccess = ({ data }) => {
  return {
    type: FETCH_EQUIPMENT_SUB_TYPE_BY_ASSET_SUCCESS,
    data,
  };
};

export const unmountSaleOrder = () => {
  return {
    type: UNMOUNT_SALE_ORDER_SUCCESS,
  }
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { saleOrder } = store.getState();
      const { query } = saleOrder;
      const response = await axios.get(`/sale-order?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { saleOrder } = store.getState();
      const { query } = saleOrder;
      const response = await axios.get(`/sale-order/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchEquipmentSubType = (val) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset/getEquipmentSubType?asset=${val}`);
      dispatch(fetchSuccess());
      dispatch(fetchEquipmentSubTypeSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchAssetsByLocation = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/sale-order/asset/location?id=${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetsByLocationSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item };
        delete data.file;
        documentData.push(data)
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('assets', JSON.stringify(payload.assets));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }
        if (key === 'assets') {
          return
        }
        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/sale-order`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      if (response && response.data && response.data.code === 404) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        history.push('/sale-order');
        dispatch(getResource());
      }
    } catch (error) {
      console.log("Error****:", error);
      message.error(error.response.data.message);
      dispatch(fetchError(error));

    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = { ...item };
          delete data.file;
          documentData.push(data);
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));
      formData.append('assets', JSON.stringify(payload.assets));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return
        }
        if (key === 'assets') {
          return
        }
        formData.append(key, payload[key]);
      });
      await axios.put(`/sale-order/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());
      history.push('/sale-order');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/sale-order/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/sale-order/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResourceWithExcel = (files, payload) => {
  // console.log(payload)
  // console.log(files)
  return async (dispatch) => {
    dispatch(fetchStart());
    dispatch(setContractUploading(true));
    try {
      let formData = new FormData();

      files.map((item) => {
        formData.append('files', item);
      });

      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item };
        delete data.file;//
        documentData.push(data)
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/sale-order/import-assets`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      const { data } = response;
      // console.log(data)
      if (data && data.soNo) {
        message.success(`Sale records ${data.soNo} with ${data.assets.length} assets created`)
      } else {
        message.error(`Sale records not created`)
      }
      //const response = await axios.post(`/contract`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      dispatch(getResource());
      dispatch(setContractUploading(false));
      // message.success('sale-order added');
      history.push('/sale-order');
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error));
      dispatch(setContractUploading(false));
      // const msg = (error.response.data.message || '').split('\n').map((item, i) => <p key={i}>{item}</p>);
      message.error(error.response.data.message);
    }
  }
};

export const setContractUploading = (data) => {
  return {
    type: SET_CONTRACT_UPLOAD,
    data
  };
};
